import { Component, Input } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-tag',
	imports: [SharedModule],
	templateUrl: './tag.component.html',
	styleUrl: './tag.component.scss',
})
export class TagComponent {
	@Input() label = 'Tag';
	@Input() color: 'green' | 'red' | 'blue' | 'gray' | 'yellow' = 'gray';
	@Input() size: 'small' | 'large' = 'large';
}
